$(document).ready(function () {

    var onLinkClicked = function(self, $anchors){
        var thisHref = $(self).attr('href');
        var $anchorEl = $anchors.find(function(el) {
            return '#' + $(el).attr('id') == thisHref;
        });

        $('html,body').animate({
            scrollTop: $($anchorEl).offset().top - 99
        }, 500);
    }

    var setLastAnchorSpacingForMenu = function($self, $anchors, $lastAnchor){
        if($anchors.length > 1){
            $lastAnchor.parent().css({
                'margin-top' : $($self).outerHeight(true) + 'px',
                'margin-bottom' : '0px'
            });
        }
    }

    $('.sticky-secondary-nav-container').each(function(){
        var $self = $(this);
        var anchorPoints = [];
        var selfTop = null;
        var $anchors = [];
        var $links = $self.find('ul:not(.mobile-dropdown-secondary-nav) li a');
        var $mobileLinks = $self.find('ul.mobile-dropdown-secondary-nav li a');
        var $activeAnchor;
        var $lastAnchor;
        var $mobileMenuBtn = $self.find('.mobile-dropdown-btn');
        var $mobileMenu = $self.find('.mobile-dropdown');

        selfTop = $($self).offset().top - parseFloat($($self).css('marginTop').replace(/auto/, 0));
        $links.toArray().forEach(function(el, i) {
            anchorPoints.push($(el).attr('href'));
            $anchors.push($('.anchor-container'+$(el).attr('href')+''));
        });
        $lastAnchor = $anchors[$anchors.length ? $anchors.length - 1 : 0];

        $mobileMenuBtn.on('click', function(){
            $mobileMenu.slideToggle(300);
        })

        $links.on('click', function(e){
            onLinkClicked(this, $anchors);
        })

        $mobileLinks.on('click', function(e){
            onLinkClicked(this, $anchors);
            $mobileMenu.slideUp(300);
        })

        $(window).scroll(function () {
            var yPos = $(this).scrollTop();
            if (yPos >= selfTop) {
                $self.addClass('nav-fixed');
            }else{
                $self.removeClass('nav-fixed');
                $links.parent().removeClass('active');
                $activeAnchor = null;
            }

            $.each($anchors, function (i, el) { 
                if($(el).length && yPos >= $(el).offset().top - 100){
                    $activeAnchor = $(el);
                }
            });

            if($activeAnchor && $activeAnchor.length){
                $links.parent().removeClass('active');
                $links.filter('[href="#'+$activeAnchor.attr('id')+'"]').parent().addClass('active');
                if($activeAnchor.attr('id') == $lastAnchor.attr('id')){
                    $self.addClass('last-position').css({
                        'top' : $lastAnchor.offset().top - parseInt($lastAnchor.parent().css('margin-top')) + 'px'
                    });
                }else{
                    $self.removeClass('last-position').attr('style', '');
                }
            }
        });

        $(window).on('resize', function () {
            setLastAnchorSpacingForMenu($self, $anchors, $lastAnchor);
            selfTop = $($self).offset().top - parseFloat($($self).css('marginTop').replace(/auto/, 0));
            $self.removeClass('nav-fixed');
            $links.parent().removeClass('active');
            $activeAnchor = null;
        });
        setLastAnchorSpacingForMenu($self, $anchors, $lastAnchor);
    })
})